export const LogoFont = "'Arima', cursive";